/**
 * Security Utilities (ES Module)
 * XSS-Schutz und sichere HTML-Verarbeitung
 */

import DOMPurify from 'dompurify';

export function escapeHtml(text) {
    if (text === null || text === undefined) return '';
    const str = String(text);
    const htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    return str.replace(/[&<>"']/g, char => htmlEscapes[char]);
}

export function sanitizeHtml(html, options = {}) {
    if (html === null || html === undefined) return '';
    const defaultConfig = {
        ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'a', 'p', 'br', 'ul', 'ol', 'li', 'span', 'div', 'table', 'thead', 'tbody', 'tr', 'th', 'td', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'pre', 'code'],
        ALLOWED_ATTR: ['href', 'target', 'class', 'id', 'style', 'title', 'colspan', 'rowspan'],
        ALLOW_DATA_ATTR: false,
        FORBID_ATTR: ['onerror', 'onclick', 'onload', 'onmouseover'],
        ...options
    };
    return DOMPurify.sanitize(html, defaultConfig);
}

export function sanitizeToText(html) {
    if (html === null || html === undefined) return '';
    return DOMPurify.sanitize(html, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
}

export function setInnerHtml(element, html, options = {}) {
    if (!element) return;
    element.innerHTML = sanitizeHtml(html, options);
}

export function setTextContent(element, text) {
    if (!element) return;
    element.textContent = text ?? '';
}

export function escapeTableCell(value) {
    if (value === null || value === undefined) {
        return '<span class="text-gray-400">—</span>';
    }
    const str = String(value);
    if (str.length > 100) {
        const escaped = escapeHtml(str.substring(0, 97));
        const fullEscaped = escapeHtml(str);
        return `<span title="${fullEscaped}">${escaped}...</span>`;
    }
    return escapeHtml(str);
}

export function sanitizeUrl(url) {
    if (!url || typeof url !== 'string') return null;
    const trimmed = url.trim().toLowerCase();
    if (trimmed.startsWith('javascript:') || trimmed.startsWith('data:') || trimmed.startsWith('vbscript:')) {
        return null;
    }
    return url;
}

export const Security = {
    escapeHtml,
    sanitizeHtml,
    sanitizeToText,
    setInnerHtml,
    setTextContent,
    escapeTableCell,
    sanitizeUrl
};
